<template>
<b-navbar toggleable="md" type="dark" variant="dark" class="sticky-top px-0" ref="app-navbar">
  <div class="container flex-column flex-row">
    <form class="d-flex align-items-center align-self-stretch py-0">
      <div class="d-flex flex-grow-1">
        <b-button :size="''" :variant="'link-light'" class="d-md-none mr-1" @click="$store.dispatch('uiToggleModalBibleTool', true)" v-if="!nomenu">
          <i class="far fa-bars fa-fw"></i>
        </b-button>
        <div class="btn-group w-100" role="group">
          <button type="button" class="btn btn-link-light px-3" @click="onClickPrevChapter">
            <i class="far fa-angle-left fa-fw"></i>
          </button>
          <button type="button" class="btn btn-link-light w-100 py-0" @click="$store.dispatch('uiToggleModalBibleBookOpen', true)" style="line-height: 1.2">
            <span v-if="$store.state.data.current.bible">
              <small>
                {{ $store.state.data.current.bible.name }}<br>
                {{ $store.state.data.current.book.toc2 }} {{ $store.state.data.current.chapter.code }}:{{ $store.state.data.current.verse.code }}
              </small>
            </span>
          </button>
          <button type="button" class="btn btn-link-light px-3" @click="onClickNextChapter">
            <i class="far fa-angle-right fa-fw"></i>
          </button>
        </div>
      </div>
    </form>
  </div>
</b-navbar>
</template>

<script>
module.exports = {
  props: {
    nomenu: {
      type: Boolean,
      default: false,
    }
  },
  data: function () {
    return { };
  },
  computed: {
  },
  methods: {
    onClickPrevChapter(event) {
      this.$store.dispatch('dataPrevChapter').then(this.$store.dispatch('dataBibleChapterCurrent'))
    },
    onClickNextChapter(event) {
      this.$store.dispatch('dataNextChapter').then(this.$store.dispatch('dataBibleChapterCurrent'))
    },
  }
}
</script>

<style>
</style>

